import Icon from '../components/Icon.vue'

Icon.register({
  'lira-sign': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M372 256c6.8 0 12.3 5.6 12 12.4-5.2 133.8-94.3 211.6-228.4 211.6h-79.6c-6.6 0-12-5.4-12-12v-193.4l-49.4 11c-7.5 1.7-14.6-4-14.6-11.7v-41c0-5.3 4.2-10.6 9.4-11.7l54.6-12.1v-30.4l-49.4 11c-7.5 1.7-14.6-4-14.6-11.7v-41c0-5.3 4.2-10.6 9.4-11.7l54.6-12.1v-69c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v51.2l129.4-28.8c7.5-1.7 14.6 4 14.6 11.7v41c0 5.3-4.2 10.6-9.4 11.7l-134.6 29.9v30.4l129.4-28.8c7.5-1.7 14.6 4 14.6 11.7v41c0 5.3-4.2 10.6-9.4 11.7l-134.6 29.9v159.2c86.2 0 168-48 168-148.8 0-6.3 5.6-11.2 12-11.2h48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/lira-sign.js
// module id = 1524
// module chunks = 0